import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { generatePrompts, getGeneratedPromptsApi } from './query';
import { COLUMNS_ENTITIES } from './keys';
import ReactSelect from '../../../../../components/ReactSelect';
import Loading from '../../../../../components/Loading';
import { COUNTRIES } from '../../../create/countries';
import { LANGUAGES } from '../../../create/languages';
import DataTable from '../../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import ProjectEditModal from '../../../projects/modal/EditProject/modal';
import AddKeywordModal from '../addKeywordModal';
import query from '../../../../EntitiesView/query';
import { getValuesByDays } from '../../../../../helpers/appearancesDates';
import ErrorMessage from '../../../ErrorMessage';
import { v4 as uuid } from 'uuid';
import PromptsView from '../PromptsView';
import DomainImage from '../../../../../components/DomainImage';
import { isTrue } from '../../../../../helpers/isTrue';
import {
    getStoredCountryLanguage,
    resolveCountryLanguage,
    saveCountryLanguage,
} from '../../../../../helpers/aiTrackingCountryLanguage';

class Entities extends Component {
    constructor(props) {
        super(props);

        this.handleSelectCountry = this.handleSelectCountry.bind(this);
        this.handleSelectProject = this.handleSelectProject.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onOpenEditModal = this.onOpenEditModal.bind(this);
        this.onCloseEditModal = this.onCloseEditModal.bind(this);
        this.openAddKeywordModal = this.openAddKeywordModal.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.onSelectDomain = this.onSelectDomain.bind(this);
        this.getEntities = this.getEntities.bind(this);
        this.onSelectEntities = this.onSelectEntities.bind(this);
        this.onSelectPrompts = this.onSelectPrompts.bind(this);
        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.isSelectDisabled = this.isSelectDisabled.bind(this);
        this.onGetEntities = this.onGetEntities.bind(this);
        this.onSelectAllPrompts = this.onSelectAllPrompts.bind(this);
        this.createOptionsList = this.createOptionsList.bind(this);
        this.checkPermissions = this.checkPermissions.bind(this);

        this.showParentOpened = this.showParentOpened.bind(this);
        this.onClickOnParentStep = this.onClickOnParentStep.bind(this);

        const userCountryLanguage = getStoredCountryLanguage();
        // const domains = JSON.parse(this.props.domains);

        this.url = new URL(window.location);
        this.projectId = this.url.searchParams.get('projectId');

        this.optionList = this.createOptionsList(this.props.domains);

        this.state = {
            selectedCollapse: ['l-0', 'r-0'],
            selectedParentCollapse: 1,
            brand: '',
            entities: [],
            errors: {},
            loading: false,
            country: userCountryLanguage?.country ?? '',
            language: userCountryLanguage?.language ?? '',
            projects: [],
            selectedProject: '',
            projectLoader: false,
            isEditModalOpen: false,
            isInProgress: false,
            prompts: [],
            selectedItems: [],
            selectedEntities: [],
            isAddKeywordModalOpen: false,
            data: [],
            topics: [],
            domainLoading: false,
            selectedDomainId: '',
            searchedEntity: false,
            showStep3: false,
            showStep4: false,
            showDiscoverAnalytics: false,
            discoverAnalyticsLoading: true,
        };

        const lastMonthDays = getValuesByDays(30);
        this.customDates = {
            start_date: lastMonthDays.prior_start_date,
            end_date: lastMonthDays.prior_end_date,
        };
    }

    checkPermissions() {
        const permissions = window.user_permissions || {};
        this.setState({
            showDiscoverAnalytics: permissions?.discover_analytics || false,
            discoverAnalyticsLoading: false,
        });
    }

    customFilter(option, inputValue) {
        return option?.data?.url?.toLowerCase()?.includes(inputValue.toLowerCase());
    }

    componentDidMount() {
        document.addEventListener('getPermissionsEvent', this.checkPermissions);
    }

    componentWillUnmount() {
        document.removeEventListener('getPermissionsEvent', this.checkPermissions);
    }

    createOptionsList(domains) {
        const optionList = domains.map((domain) => ({
            id: domain.id,
            url: domain.url,
            value: domain.id,
            label: (
                <div className="gsc-test-user">
                    <div>{domain.url}</div>
                    {isTrue(window.is_superuser) && (
                        <div>
                            {domain.active ? (
                                <i className="text-success icofont-verification-check"></i>
                            ) : (
                                <i className=" text-danger icofont-ui-close"></i>
                            )}{' '}
                        </div>
                    )}
                </div>
            ),
        }));
        return optionList;
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.projects) !== JSON.stringify(prevProps.projects)) {
            if (!this.projectId) return;
            const selectedProject =
                this.props.projects.find((x) => Number(x.id) === Number(this.projectId)) ?? null;
            if (selectedProject) {
                this.setState({
                    selectedProject: selectedProject.value,
                    ...resolveCountryLanguage(selectedProject),
                });
            }
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.prompt?.toLowerCase().includes(search.toLowerCase());
        });
    }

    sortByOrder(data) {
        if (!Array.isArray(data)) return data;
        return [...data].sort((a, b) => (a?.ord ?? 0) - (b?.ord ?? 0));
    }

    showOpened(name, value) {
        return this.state.selectedCollapse.includes(name) ? value ?? 'active' : '';
    }

    onOpenEditModal() {
        this.setState({ isEditModalOpen: true });
    }

    onCloseEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    openAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: true });
    }

    closeAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: false });
    }

    async getGeneratedPrompts(id) {
        try {
            const response = await getGeneratedPromptsApi(id);
            const data = await response.json();

            if (data.status === 'completed') {
                const topics = this.sortByOrder(data?.response_data?.entity_prompts);
                this.setState({ topics: topics ?? [], isInProgress: false });
            } else if (data.status === 'pending') {
                setTimeout(() => {
                    this.getGeneratedPrompts(id);
                }, 5000);
            } else if (data.status === 'failed') {
                this.setState({
                    isInProgress: false,
                    errorMessage:
                        data.error_message ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    openEditModal() {
        this.setState({ isEditModalOpen: true });
    }
    closeEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    handleSelectProject = (selectedOption) => {
        const project = this.props.projects.find((x) => x.value === selectedOption) ?? null;

        this.setState({
            selectedProject: selectedOption,
            errors: { ...this.state.errors, project: null, country: null, language: null },
            ...resolveCountryLanguage(project),
        });
    };

    handleSelectCountry(data) {
        this.setState({
            country: data.value,
            language: data.language,
            errors: {
                ...this.state.errors,
                country: null,
                language: null,
            },
        });
    }

    handleSelect(value, name) {
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: null } });
    }

    async onSubmit(e) {
        try {
            e.preventDefault();
            let isError = false;
            let errors = {};

            const selectedProject = this.props.projects.find(
                (x) => x.value === this.state.selectedProject,
            );

            if (!selectedProject?.own_domain || !selectedProject?.own_product_name) {
                errors.project = this.props.t(
                    'ai_tracking.prompt_generator.brand_and_domain_required',
                );
                isError = true;
            }
            if (!this.state.country) {
                errors.country = this.props.t('ai_tracking.prompt_generator.country_required');
                isError = true;
            }
            if (!this.state.language) {
                errors.language = this.props.t('ai_tracking.prompt_generator.language_required');
                isError = true;
            }

            if (isError) {
                return this.setState((prevState) => ({
                    errors: { ...prevState.errors, ...errors },
                }));
            }

            this.setState({ loading: true, showStep4: true, errorMessage: null, topics: [] });
            this.onClickOnParentStep(4);
            this.scrollToBottom();

            const formData = {
                brand_name: selectedProject?.own_product_name,
                brand_domain: selectedProject?.own_domain,
                country: this.state.country,
                language: this.state.language,
                project: this.state.selectedProject,
                entities: this.state.selectedEntities,
            };

            saveCountryLanguage({
                country: this.state.country,
                language: this.state.language,
            });

            const response = await generatePrompts(formData);
            const data = await response.json();

            if (data.status === 'completed') {
                const topics = this.sortByOrder(data?.response_data?.entity_prompts);
                this.setState({ topics });
            } else if (data.status === 'pending') {
                this.getGeneratedPrompts(data.id);
                this.setState({ isInProgress: false });
            } else if (data.status === 'failed' || response.status > 201) {
                this.setState({
                    isInProgress: false,
                    errorMessage:
                        data.error_message ??
                        data.detail ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }
            this.scrollToBottom();
        } catch (err) {
            console.log('err', err);
        } finally {
            this.setState({ loading: false });
        }
    }

    onSelectEntities(name) {
        this.setState({
            selectedEntities: this.state.selectedEntities.includes(name)
                ? this.state.selectedEntities.filter((item) => item !== name)
                : [...this.state.selectedEntities, name],
        });
    }

    searchFunctionForEntities(data, search) {
        if (!search) return data;
        return data.filter((item) => item?.name?.toLowerCase()?.includes(search.toLowerCase()));
    }

    async getEntities(domain) {
        this.query = query({ custom_domain: domain, custom_dates: this.customDates });
        this.query.bind(this.setState.bind(this));
        const data = await this.query.update();
        const results = data?.map((item) => ({
            ...item,
            id: uuid(),
        }));
        this.setState({ searchedEntity: true, data: results });
        this.scrollToBottom();
    }

    async onSelectDomain(data) {
        this.setState({
            selectedDomain: data.url,
            selectedDomainId: data.id,
        });
    }

    async onGetEntities() {
        try {
            this.setState({
                showStep3: true,
                domainLoading: true,
            });
            this.scrollToBottom();
            await this.getEntities(this.state.selectedDomain);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                domainLoading: false,
            });
        }
    }

    onSelectPrompts(prompt) {
        this.setState({
            selectedItems: this.state.selectedItems.includes(prompt)
                ? this.state.selectedItems.filter((item) => item !== prompt)
                : [...this.state.selectedItems, prompt],
        });
    }

    onSelectAllPrompts(prompts) {
        const allSelected = prompts.every((prompt) => this.state.selectedItems.includes(prompt));
        this.setState({
            selectedItems: allSelected
                ? this.state.selectedItems.filter((item) => !prompts.includes(item))
                : [...new Set([...this.state.selectedItems, ...prompts])],
        });
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: this.state.selectedCollapse.includes(id)
                ? this.state.selectedCollapse.filter((item) => item !== id)
                : [...this.state.selectedCollapse, id],
        });
    }

    showParentOpened(name, value) {
        return this.state.selectedParentCollapse === name ? value ?? 'active' : '';
    }

    onClickOnParentStep(id) {
        this.setState({
            selectedParentCollapse: this.state.selectedParentCollapse === id ? null : id,
        });
    }

    isSelectDisabled(item) {
        return (
            this.state.selectedEntities?.length >= 5 &&
            !this.state.selectedEntities?.includes(item.name)
        );
    }

    scrollToBottom() {
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
        }, 100);
    }

    render() {
        const { t } = this.props;
        const selectedProject =
            this.props.projects.find((x) => x.value === this.state.selectedProject) ?? null;

        const disableSecondStep = !selectedProject?.own_product_name;
        const disableThirdStep = disableSecondStep || !this.state.language || !this.state.country;
        const disabableFourthStep =
            !this.state.selectedEntities.length ||
            this.state.isInProgress ||
            this.state.loading ||
            this.props.promptCredits <= 0;

        const entitiesColumn = COLUMNS_ENTITIES(
            t,
            this.onSelectEntities,
            this.state.selectedEntities,
        );
        this.optionList = this.createOptionsList(this.props.domains);
        const projectOptions = this.props.projects.map((project) => ({
            label: (
                <div className="d-flex align-items-center gap-8">
                    {project.label}{' '}
                    {project.is_default && (
                        <span className="ai-tracking-default-selected white">
                            {t('ai_tracking.global.default')}
                        </span>
                    )}
                </div>
            ),
            value: project.value,
        }));

        return (
            <>
                {this.state.discoverAnalyticsLoading ? (
                    <div className="card">
                        <div className="card-body">
                            <Loading />
                        </div>
                    </div>
                ) : null}
                {!this.state.discoverAnalyticsLoading && !this.state.showDiscoverAnalytics && (
                    <div className="card">
                        <div className="card-body">
                            {t('ai_tracking.prompt_generator.entities.connect_discover.message')}
                            <a className="ai-tracking-link" href="/customers/change_plan/">
                                {t('ai_tracking.prompt_generator.entities.connect_discover.link')}
                            </a>
                        </div>
                    </div>
                )}
                {this.state.showDiscoverAnalytics &&
                    this.state.discoverAnalyticsLoading &&
                    this.props.domainsLoader && (
                        <div className="card">
                            <div className="card-body">
                                <Loading />
                            </div>
                        </div>
                    )}
                {this.state.showDiscoverAnalytics &&
                    this.props.domains?.length === 0 &&
                    !this.props.domainsLoader && (
                        <div className="card">
                            <div className="card-body">
                                {t('ai_tracking.prompt_generator.no_active_domain')}
                            </div>
                        </div>
                    )}

                {this.state.showDiscoverAnalytics && !!this.props.domains?.length && (
                    <>
                        <div className="card">
                            <div className="card-body">
                                <div className="prompt-generator-title">
                                    <div className="prompt-generator-number">1</div>
                                    <div className="prompt-generator-label">
                                        {t('ai_tracking.add_keyword.project')}
                                        {selectedProject && (
                                            <div className="prompt-generator-selected-project">
                                                <DomainImage
                                                    domain_name={selectedProject?.own_domain}
                                                    size="20"
                                                />
                                                <div>{selectedProject?.own_product_name}</div>
                                                <span>{selectedProject?.own_domain}</span>
                                                <button
                                                    onClick={this.onOpenEditModal}
                                                    disabled={!selectedProject}
                                                >
                                                    <i className="icon-pencil" />
                                                </button>
                                            </div>
                                        )}
                                        {selectedProject && !selectedProject?.own_domain && (
                                            <div className="error-message">
                                                {t(
                                                    'ai_tracking.prompt_generator.project_inclomplete_message',
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="prompt-generator-selects-box">
                                    <div>
                                        <ReactSelect
                                            options={projectOptions}
                                            value={selectedProject}
                                            onChange={this.handleSelectProject}
                                            blurInputOnSelect={true}
                                            label={
                                                <div className="select-label">
                                                    {t('ai_tracking.global.project')} <span>*</span>
                                                </div>
                                            }
                                            classname="mr-0"
                                            disabled={this.props.projectLoader}
                                            isSearchable
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                        {this.state.errors['project'] && (
                                            <div className="error-message">
                                                {this.state.errors['project']}
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <ReactSelect
                                            options={COUNTRIES}
                                            value={COUNTRIES.find(
                                                (x) => x.value === this.state.country,
                                            )}
                                            label={
                                                <div className="select-label">
                                                    {t('ai_tracking.add_keyword.country')}{' '}
                                                    <span>*</span>
                                                </div>
                                            }
                                            placeholder={t('ai_tracking.add_keyword.country')}
                                            customeOnChange={this.handleSelectCountry}
                                            blurInputOnSelect={true}
                                            classname="mr-0"
                                            disabled={this.state.loading}
                                            isSearchable
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                        {this.state.errors['country'] && (
                                            <div className="error-message">
                                                {this.state.errors['country']}
                                            </div>
                                        )}
                                    </div>

                                    <div>
                                        <ReactSelect
                                            options={LANGUAGES}
                                            value={LANGUAGES.find(
                                                (x) => x.value === this.state.language,
                                            )}
                                            label={
                                                <div className="select-label">
                                                    {t('ai_tracking.add_keyword.language')}{' '}
                                                    <span>*</span>
                                                </div>
                                            }
                                            placeholder={t('ai_tracking.add_keyword.language')}
                                            onChange={(e) => this.handleSelect(e, 'language')}
                                            blurInputOnSelect={true}
                                            classname="mr-0"
                                            disabled={this.state.loading}
                                            isSearchable
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                        {this.state.errors['language'] && (
                                            <div className="error-message">
                                                {this.state.errors['language']}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.props.projectLoader && <Loading padding="10px 0" />}
                            </div>
                        </div>
                        {selectedProject && (
                            <div className="card">
                                <div className="card-body">
                                    <div className="prompt-generator-title">
                                        <div className="prompt-generator-number">2</div>
                                        <div className="prompt-generator-label">
                                            {t('ai_tracking.prompt_generator.select_domain')}
                                        </div>
                                    </div>
                                    {disableThirdStep ? (
                                        <div className="prompt-generator-subtitle">
                                            {t(
                                                'ai_tracking.prompt_generator.select_domain_subtitle',
                                            )}
                                        </div>
                                    ) : (
                                        <div className="ai-tracking-brands-box">
                                            <div>
                                                <ReactSelect
                                                    options={this.optionList}
                                                    value={this.optionList.find(
                                                        (x) => x.id === this.state.selectedDomainId,
                                                    )}
                                                    label={
                                                        <div className="select-label">
                                                            {t(
                                                                'ai_tracking.prompt_generator.entities.selectDomain',
                                                            )}{' '}
                                                            <span>*</span>
                                                        </div>
                                                    }
                                                    customeOnChange={this.onSelectDomain}
                                                    blurInputOnSelect={true}
                                                    classname="mb-10"
                                                    disabled={this.state.domainLoading}
                                                    components={{
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    customFilter={this.customFilter}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="mt-18 d-flex justify-content-end">
                                        <div>
                                            <button
                                                onClick={this.onGetEntities}
                                                className="button button-filled button-primary"
                                                disabled={
                                                    !this.state.selectedDomainId ||
                                                    this.state.domainLoading
                                                }
                                            >
                                                {t('ai_tracking.global.display_entities')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.showStep3 && (
                            <div className="card">
                                <div className="card-body">
                                    <div className="prompt-generator-title">
                                        <div className="prompt-generator-number">3</div>
                                        <div className="prompt-generator-label">
                                            {t('ai_tracking.prompt_generator.select_entities')}
                                        </div>
                                    </div>
                                    {!this.state.domainLoading &&
                                        !this.state.data?.length &&
                                        !this.state.searchedEntity && (
                                            <div className="prompt-generator-subtitle">
                                                {t('ai_tracking.prompt_generator.entities_message')}
                                            </div>
                                        )}
                                    {!this.state.domainLoading &&
                                        !this.state.data?.length &&
                                        this.state.searchedEntity && (
                                            <div className="prompt-generator-subtitle">
                                                {t('global.no_data')}
                                            </div>
                                        )}
                                    {!this.state.domainLoading && !!this.state.data?.length && (
                                        <div className="prompt-generator-subtitle">
                                            {t(
                                                'ai_tracking.prompt_generator.entities_select_limit',
                                            )}
                                        </div>
                                    )}

                                    <div className="ai-tracking-brands-box">
                                        <div>
                                            {this.state.domainLoading && <Loading />}
                                            {this.state.data?.length > 0 && (
                                                <DataTable
                                                    nodes={this.state.data}
                                                    notUseDefaultStyle
                                                    sortFns={getSortKeys(entitiesColumn)}
                                                    COLUMNS={entitiesColumn}
                                                    fileName={t('discover.entities.title')}
                                                    searchFunction={this.searchFunctionForEntities}
                                                    defaultSortKey={'pages'}
                                                    additionalStyles={setAdditionalStyles(
                                                        entitiesColumn,
                                                    )}
                                                />
                                            )}
                                        </div>
                                        {this.state.errors?.entities && (
                                            <div className="error-message">
                                                {this.state.errors.entities}
                                            </div>
                                        )}
                                        {this.state.data?.length > 0 && (
                                            <>
                                                <div className="mt-18 d-flex justify-content-end">
                                                    <div>
                                                        <button
                                                            onClick={this.onSubmit}
                                                            className="button button-filled button-primary"
                                                            disabled={disabableFourthStep}
                                                        >
                                                            {t(
                                                                'ai_tracking.prompt_generator.generate_prompts',
                                                            )}
                                                        </button>
                                                        <div className="prompt-generation-count">
                                                            {this.props.getCreditsLoader ? (
                                                                <Loading />
                                                            ) : (
                                                                <>
                                                                    {this.props.promptCredits}{' '}
                                                                    {t(
                                                                        'ai_tracking.global.prompts_generation_left',
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {!this.props.getCreditsLoader &&
                                            this.props.promptCredits === 0 && (
                                                <ErrorMessage
                                                    message={t(
                                                        'ai_tracking.global.prompts_generation_left_message',
                                                    )}
                                                />
                                            )}
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.showStep4 && (
                            <div className="card">
                                <div className="card-body">
                                    <div className="prompt-generator-title">
                                        <div className="prompt-generator-number">4</div>
                                        <div className="prompt-generator-label">
                                            {t('ai_tracking.prompt_generator.select_prompts')}
                                        </div>
                                    </div>
                                    <div>
                                        {(this.state.isInProgress || this.state.loading) && (
                                            <div className="mt-20 d-flex gap-8">
                                                <strong>
                                                    {t(
                                                        'ai_tracking.prompt_generator.generate_message',
                                                    )}
                                                </strong>{' '}
                                                <Loading />{' '}
                                            </div>
                                        )}
                                        {this.state.errorMessage && (
                                            <div className="mt-20 error-message">
                                                <strong>{this.state.errorMessage}</strong>{' '}
                                            </div>
                                        )}
                                    </div>
                                    {!this.state.topics.length &&
                                        !this.state.isInProgress &&
                                        !this.state.loading && (
                                            <div className="prompt-generator-subtitle">
                                                {t(
                                                    'ai_tracking.prompt_generator.track_prompt_subtitle',
                                                )}
                                            </div>
                                        )}

                                    {this.state.topics?.length > 0 && (
                                        <>
                                            <div className="prompt-generator-body-box">
                                                <div className="prompt-generator-body-box-content">
                                                    {this.state.topics
                                                        .filter((_, i) => i % 2 === 0)
                                                        ?.map((item, i) => (
                                                            <PromptsView
                                                                item={item}
                                                                showOpened={this.showOpened}
                                                                onClickOnStep={this.onClickOnStep}
                                                                headerKey={'entity'}
                                                                selectedItems={
                                                                    this.state.selectedItems
                                                                }
                                                                onSelectPrompts={
                                                                    this.onSelectPrompts
                                                                }
                                                                uniqueKey={`l-${i}`}
                                                                key={i}
                                                                onSelectAllPrompts={
                                                                    this.onSelectAllPrompts
                                                                }
                                                            />
                                                        ))}
                                                </div>
                                                <div className="prompt-generator-body-box-content">
                                                    {this.state.topics
                                                        .filter((_, i) => i % 2 === 1)
                                                        ?.map((item, i) => (
                                                            <PromptsView
                                                                item={item}
                                                                showOpened={this.showOpened}
                                                                onClickOnStep={this.onClickOnStep}
                                                                headerKey={'entity'}
                                                                selectedItems={
                                                                    this.state.selectedItems
                                                                }
                                                                onSelectPrompts={
                                                                    this.onSelectPrompts
                                                                }
                                                                uniqueKey={`r-${i}`}
                                                                key={i}
                                                                onSelectAllPrompts={
                                                                    this.onSelectAllPrompts
                                                                }
                                                            />
                                                        ))}
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-end mt-3 mb-5">
                                                <div>
                                                    <button
                                                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center gap-4"
                                                        onClick={this.openAddKeywordModal}
                                                        disabled={
                                                            this.state.selectedItems.length === 0
                                                        }
                                                    >
                                                        {t(
                                                            'ai_tracking.prompt_generator.track_selected_prompts',
                                                        )}
                                                        <div className="selected-items-count-for-track">
                                                            {this.state.selectedItems.length}
                                                        </div>
                                                    </button>
                                                    <div className="prompt-generation-count">
                                                        {this.props.balanceLoader ? (
                                                            <Loading />
                                                        ) : (
                                                            <>
                                                                {this.props.available_credits}{' '}
                                                                {t(
                                                                    'ai_tracking.global.prompts_tracking_left',
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {!this.props.balanceLoader &&
                                                this.props.available_credits === 0 && (
                                                    <ErrorMessage
                                                        message={t(
                                                            'ai_tracking.global.prompts_tracking_left_message',
                                                        )}
                                                    />
                                                )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </>
                )}
                {selectedProject && this.state.isEditModalOpen && (
                    <ProjectEditModal
                        isOpen={this.state.isEditModalOpen}
                        onClose={this.onCloseEditModal}
                        item={selectedProject}
                        updateData={this.props.getProjectsData}
                    />
                )}
                {this.state.isAddKeywordModalOpen && (
                    <AddKeywordModal
                        isOpen={this.state.isAddKeywordModalOpen}
                        onClose={this.closeAddKeywordModal}
                        prompts={this.state.selectedItems}
                        projectId={this.state.selectedProject}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Entities);
